// The one status chip of a client question (ADR-0035): the same colour tokens, icon + words as the issue chips, wherever a question appears —
// the Client questions tab, the question page, the decision dialog. Everything shown is the engine's chip (lib/questions qChipOf).
import { QUESTION_STATE, qChipIcon, qChipKind, qChipOf, type QuestionChip } from "../lib/questions";
import { CHIP_CLS } from "./IssueStatusChip";

export function QuestionStatusChip({ question, chip, className = "" }: { question?: { status?: string | null; chip?: QuestionChip | null } | null; chip?: QuestionChip | null; className?: string }) {
  const c = chip ?? qChipOf(question ?? {});
  const kind = qChipKind(c);
  const title = c.reason ? `${c.label}: ${c.reason}` : c.portal ? `${c.label} (in the client portal)` : undefined;
  return (
    <span data-question-state={c.state} data-status={kind} title={title}
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded border px-1.5 py-0.5 text-xs font-medium ${CHIP_CLS[kind]} ${className}`}>
      <span aria-hidden="true">{qChipIcon(c)}</span>{c.text || c.label}
    </span>
  );
}

/** A count of questions in one status (the tab's header), in the chip's colour, icon and words. */
export function QuestionStateCount({ state, count }: { state: string; count: number }) {
  const meta = QUESTION_STATE[state] ?? QUESTION_STATE.draft;
  return (
    <span data-question-state={state} data-status={meta.kind}
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded border px-1.5 py-0.5 text-xs font-medium ${CHIP_CLS[meta.kind]}`}>
      <span aria-hidden="true">{meta.icon}</span><span className="tabular-nums">{count}</span> {meta.label}
    </span>
  );
}
